import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {TxnTemplateDto} from "../../model/TxnTemplateDto";
import {TxnTemplateLineDto} from "../../model/TxnTemplateLineDto";
import {TxnTemplateInterval} from "../../model/TxnTemplateInterval";
import * as moment from 'moment';
import {AuthorizeNetPaymentProfileDto} from "../../model/AuthorizeNetPaymentProfileDto";

export default class EditController implements Ng1Controller {
    private model: TxnTemplateDto;

    $onInit(): void {
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.client.onTxnTemplateOneUpdated(e => {
            this.model = e;
            this.model.lines.forEach(line=> {
            })
        });
        $dataHub.onConnected(this.refresh);
        this.model = new TxnTemplateDto();
        this.model.interval = new TxnTemplateInterval();
        this.model.interval.next = moment().startOf('day').toDate();
        let line = new TxnTemplateLineDto();
        line.lineNumber = 1;
        this.model.lines.push(line);
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        if (this.$stateParams.txnTemplateGuid)
            this.$dataHub.server.txnTemplateSubscribeOne(this.$stateParams.txnTemplateGuid)
                .catch(this.$dataHub.defaultErrorHandler);
    };

    lineAdd = () => {
        let line = new TxnTemplateLineDto();
        line.lineNumber = Math.max.apply(this, this.model.lines.map(l => l.lineNumber)) + 1;
        if (!isFinite(line.lineNumber))
            line.lineNumber = 1;
        this.model.lines.push(line);
    };

    lineDelete = line => {
        this.model.lines.remove(line, x => x);
    };

    save = () => {
        this.$dataHub.server.txnTemplateModify(this.model)
            .then(r => window.close())
            .catch(this.$dataHub.defaultErrorHandler);
    }


    get autoDebitProfileOverride() {
        return this.model.autoDebitProfile != undefined;
    }
    set autoDebitProfileOverride(value: boolean) {
        if(value) {
            let ret = confirm('This should only be used if the customer has multiple subscriptions they want billed to different cards.' +
                '\n\n' +
                'Otherwise, please update the customer default payment profile in the customer screen');
            if(!ret) return;
            this.model.autoDebitProfile = new AuthorizeNetPaymentProfileDto();
        } else {
            this.model.autoDebitProfile = null;
        }

    }

    get nextInPast() {
        return this.model.interval.next < moment().startOf('day').toDate();
    }
}
